var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('f-hidden-nav-link',{attrs:{"to":"main"}},[_vm._v(_vm._s(_vm.$t('skipToContent')))]),_c('app-header'),_c('main',{attrs:{"id":"main","tabindex":"-1"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }